/** Must stay aligned with `EXISTING_USER_ERROR_MESSAGE` in signupGuard.service.ts */
export const EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_BACKEND_MESSAGE =
  "User is already existing. Please login via Winners Locker App instead.";

export const EXISTING_ACTIVE_MEMBER_WEB_SIGNUP_ERROR_MARKER =
  "user is already existing";
